package com.essntl.features.itinerary.data.supabase.itineraries_to_confirm

import com.essntl.features.itinerary.domain.model.ItineraryToConfirmModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ItineraryToConfirmDto(
    @SerialName("itinerary_id")
    val id: String,
    @SerialName("itinerary_created_at")
    val createdAt: String,
    @SerialName("proposal_title")
    val title: String,
    @SerialName("owner_name")
    val ownerName: String,
    @SerialName("owner_id")
    val ownerId: String,
    @SerialName("proposal_from_date")
    val fromDate: String,
    @SerialName("proposal_to_date")
    val toDate: String,
    @SerialName("unconfirmed_service_count")
    val unconfirmedServiceCount: Int,
    @SerialName("total_services")
    val totalServices: Int,
    @SerialName("client_name")
    val clientName: String,
) {
    fun toModel() =
        ItineraryToConfirmModel(
            id = id,
            createdAt = createdAt,
            title = title,
            ownerName = ownerName,
            ownerId = ownerId,
            fromDate = fromDate,
            toDate = toDate,
            unconfirmedServiceCount = unconfirmedServiceCount,
            totalServices = totalServices,
            clientName = clientName,
        )
}